import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger, SplitText);

function menu() {

    /////////////////// Lang switcher
    //////////////////////////////////////////
    const langSwitchers = document.querySelectorAll('.lang-switcher');

    langSwitchers.forEach(langSwitcher => {
        const toggle = langSwitcher.querySelector('.lang-switcher__toggle');

        toggle?.addEventListener('click', () => {
            langSwitcher.classList.toggle('is-open');
            toggle.setAttribute(
                'aria-expanded',
                langSwitcher.classList.contains('is-open')
            );
        });
    });

    // cerrar al hacer click fuera
    document.addEventListener('click', (e) => {
        langSwitchers.forEach(langSwitcher => {
            const toggle = langSwitcher.querySelector('.lang-switcher__toggle');
            if (!langSwitcher.contains(e.target)) {
                langSwitcher.classList.remove('is-open');
                toggle?.setAttribute('aria-expanded', 'false');
            }
        });
    });
    
    /////////////////// Menu color detection
    //////////////////////////////////////////

    // Detectar el color del primer block y aplicarlo como variable global
    const firstBlock = document.querySelector('.block--1');

    if (firstBlock) {
        // Obtener el valor de --block-bg del primer block
        const blockBg = getComputedStyle(firstBlock).getPropertyValue('--block-bg').trim();

        if (blockBg) {
            // Asignar el color como variable global en :root
            document.documentElement.style.setProperty('--header-bg', blockBg);
        }
    }

    /////////////////// Dynamic image menu
    //////////////////////////////////////////
    
    // const menuItems = document.querySelectorAll('.main-menu li[data-menu-image]');
    // const imageContainer = document.querySelector('.main-menu__image');

    /*
    if (menuItems.length && imageContainer) {
        // Mostrar imagen del item activo al cargar
        const currentItem = document.querySelector('.main-menu .current-menu-item[data-menu-image], .main-menu .current-menu-parent[data-menu-image]');
        if (currentItem) {
            const imageUrl = currentItem.getAttribute('data-menu-image');
            imageContainer.src = imageUrl;
            imageContainer.style.display = 'block';
            imageContainer.classList.add('is-visible');
        }

        // Cambiar imagen en hover
        menuItems.forEach(item => {
            const link = item.querySelector('a');
            if (!link) return;

            link.addEventListener('mouseenter', () => {
                const imageUrl = item.getAttribute('data-menu-image');
                if (imageUrl) {
                    imageContainer.classList.remove('is-visible');
                    imageContainer.classList.add('is-hidden');
                    
                    setTimeout(() => {
                        imageContainer.src = imageUrl;
                        imageContainer.style.display = 'block';
                        imageContainer.classList.remove('is-hidden');
                        imageContainer.classList.add('is-visible');
                    }, 150);
                }
            });
        });

        // Restaurar imagen del item activo al salir del menú
        const menuWrapper = document.querySelector('.main-menu__wrapper');
        if (menuWrapper) {
            menuWrapper.addEventListener('mouseleave', () => {
                if (currentItem) {
                    const imageUrl = currentItem.getAttribute('data-menu-image');
                    imageContainer.classList.remove('is-visible');
                    imageContainer.classList.add('is-hidden');
                    
                    setTimeout(() => {
                        imageContainer.src = imageUrl;
                        imageContainer.classList.remove('is-hidden');
                        imageContainer.classList.add('is-visible');
                    }, 150);
                } else {
                    imageContainer.style.display = 'none';
                }
            });
        }
    }
    */

    // Funcionalidad del menú burger
    initBurgerMenu();

    // Funcionalidad del header fixed con scroll
    initHeaderScroll();
}

function initHeaderScroll() {
    
    const headerNormal = document.querySelector('.header__right--normal');
    const headerFixed = document.querySelector('.header__right--fixed');

    if (!headerNormal || !headerFixed) return;

    // Estado inicial: fixed oculto
    gsap.set(headerFixed, { 
        autoAlpha: 0,
        display: 'flex',
        y:-25
    });

    // ScrollTrigger para detectar cuando el normal sale de la pantalla
    ScrollTrigger.create({
        trigger: headerNormal,
        start: 'bottom top',
        end: 'bottom top',
        onEnter: () => {
            // El header normal salió de la pantalla hacia arriba -> mostrar fixed
            gsap.to(headerFixed, {
                autoAlpha: 1,
                y:0,
                duration: 0.3,
                ease: 'power2.out'
            });
        },
        onLeaveBack: () => {
            // El header normal vuelve a aparecer -> ocultar fixed
            gsap.to(headerFixed, {
                autoAlpha: 0,
                y:-25,
                duration: 0.3,
                ease: 'power2.in'
            });
        }
    });
}

function initBurgerMenu() {

    /////////////////// Menu Decoration Mouse Tracking
    //////////////////////////////////////////

    const faceSections = document.querySelectorAll('[data-face]');
    
    let startTracking = () => {};
    let stopTracking = () => {};

    if (faceSections.length) {
        faceSections.forEach(section => {

            const baseIntensity = parseFloat(section.getAttribute('data-face')) || 1;

            const targets = Array.from(section.querySelectorAll('[data-face-target]')).map(el => {
                const factor = parseFloat(el.getAttribute('data-face-target')) || 1;
                return {
                    el,
                    factor,
                    intensity: baseIntensity * factor,
                    setX: gsap.quickTo(el, 'xPercent', { duration: 2, ease: 'power2' }),
                    setY: gsap.quickTo(el, 'yPercent', { duration: 2, ease: 'power2' })
                };
            });

            let isTracking = false;
            let isRAFRunning = false;
            let lastMouse = { x: 0, y: 0 };

            const update = () => {
                const mx = lastMouse.x;
                const my = lastMouse.y;

                targets.forEach(target => {
                    const r  = target.el.getBoundingClientRect();
                    const cx = r.left + r.width  / 2;
                    const cy = r.top  + r.height / 2;

                    // Calcular distancia del mouse al centro del elemento
                    const dx = mx - cx;
                    const dy = my - cy;

                    // Normalizar basado en el tamaño de la ventana, no del elemento
                    const nx = dx / window.innerWidth;
                    const ny = dy / window.innerHeight;

                    // Aplicar la intensidad con un factor de escala más pequeño
                    const mappedX = nx * target.intensity * 0.5;
                    const mappedY = ny * target.intensity * 0.5;

                    target.setX(mappedX);
                    target.setY(mappedY);
                });

                isRAFRunning = false;
            };

            const onMouseMove = e => {
                lastMouse.x = e.clientX;
                lastMouse.y = e.clientY;
                if (!isRAFRunning) {
                    requestAnimationFrame(update);
                    isRAFRunning = true;
                }
            };

            startTracking = () => {
                if (!isTracking) {
                    window.addEventListener('mousemove', onMouseMove);
                    isTracking = true;
                }
            };

            stopTracking = () => {
                if (isTracking) {
                    window.removeEventListener('mousemove', onMouseMove);
                    isTracking = false;
                }
            };
        });
    }

    /////////////////// Burger Menu Animation
    //////////////////////////////////////////
    
    const burgers = document.querySelectorAll('.header__burger');
    const sidenav = document.querySelector('.sidenav');
    const closeBtn = document.querySelector('.sidenav__close');
    const menuLinks = document.querySelectorAll('.main-menu a');

    const emitMenuState = (isOpen) => {
        window.dispatchEvent(new CustomEvent('menu:toggle', { detail: { open: isOpen } }));
    };

    if (!burgers.length || !sidenav) return;

    // Preparar SplitText para los items del menú
    const menuItems = document.querySelectorAll('.main-menu a');
    const splitTexts = [];
    
    menuItems.forEach(item => {
        const split = new SplitText(item, { type: 'words,lines', linesClass: 'split-line' });
        splitTexts.push(split);
    });

    // Estado inicial del sidenav (oculto)
    gsap.set(sidenav, { x: '-100%', visibility: 'hidden' });
    gsap.set('.sidenav__brand', { opacity: 0, y: 25 });
    gsap.set('.sidenav__close', { opacity: 0, scale: 1.5 });
    gsap.set('.sidenav__footer img', { yPercent: 110 });
    gsap.set('.sidenav__side', { x: 100, opacity: 0 });
    gsap.set('.main-menu__image-container', { opacity: 0, y: 20 });
    
    splitTexts.forEach(split => {
        gsap.set(split.words, { y: '100%' });
    });

    // Función para abrir el menú
    const openMenu = () => {

        if (document.body.classList.contains('menu-open')) return;

        document.body.classList.add('menu-open');
        emitMenuState(true);

        const tl = gsap.timeline();

        // 1. Desplazar sidenav desde la izquierda
        tl.set(sidenav, { visibility: 'visible' })
          .to(sidenav, {
              x: '0%',
              duration: 0.6,
              ease: 'power3.out'
          });

        // 2. Aparecer brand (fade) y close (fade + scale)

        tl.to('.sidenav__close', {
            opacity: 1,
            scale: 1,
            duration: 0.4,
            ease: 'back.out(1.7)'
        }, '-=0.4')

        tl.to('.sidenav__brand', {
            y: 0,
            opacity: 1,
            duration: 0.3,
            ease: 'power2.inOut'
        },) 
        
        tl.to('.sidenav__footer img', {
            yPercent: 0,
            duration: 0.3,
            ease: 'power2.out'
        }, '<');

        // 3. Aparecer botones del menú uno a uno (SplitText desde abajo)
        splitTexts.forEach((split, index) => {
            tl.to(split.words, {
                y: '0%',
                duration: 0.3,
                // stagger: 0.01,
                ease: 'power3.out'
            }, index === 0 ? '-=0.2' : '-=0.25');
        });

        // 4. Aparecer imagen del menú
        tl.to('.main-menu__image-container', {
            opacity: 1,
            y: 0,
            duration: 0.3,
            ease: 'power2.out'
        }, '-=0.3');        

        // 6. Side desde la derecha (a mitad del footer)
        tl.to('.sidenav__side', {
            x: 0,
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out'
        }, '<>');

        // Bloquear scroll del body
        document.body.style.overflow = 'hidden';

        startTracking();

    };

    // Función para cerrar el menú
    const closeMenu = () => {

        document.body.classList.remove('menu-open');
        emitMenuState(false);

        // Restaurar scroll del body
        document.body.style.overflow = '';

        stopTracking();

        const tl = gsap.timeline();

        tl.to(sidenav, {
            x: '-100%',
            duration: 0.5,
            ease: 'power3.in',
            onComplete: () => {
                gsap.set(sidenav, { visibility: 'hidden' });
                // Resetear elementos
                gsap.set('.sidenav__brand', { opacity: 0, y: 25 });
                gsap.set('.sidenav__close', { opacity: 0, scale: 1.2 });
                gsap.set('.sidenav__footer img', { yPercent: 110 });
                gsap.set('.sidenav__side', { x: 100, opacity: 0 });
                gsap.set('.main-menu__image-container', { opacity: 0, y: 20 });
                splitTexts.forEach(split => {
                    gsap.set(split.words, { y: '100%' });
                });
            }
        });
    };

    // Event listeners
    burgers.forEach(burger => {
        burger.addEventListener('click', openMenu);
    });
    
    if (closeBtn) {
        closeBtn.addEventListener('click', closeMenu);
    }

    // Cerrar al hacer click en cualquier link del menú
    menuLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });
    
}

export default menu;